import tripStatuses from '../../trip-statuses';

export default function TripDetailsTravellersController(
    $rootScope,
    $scope,
    $state,
    userService,
    tripOptionsService,
    travellerUtils,
    l10nService,
    tripDetails,
    tripId,
    tripAPI,
    ktAlert
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        initScope();
    }

    function initScope() {
        $scope.model = tripDetails;

        $scope.$watch('tripDetails', function(model) {
            $scope.model = model;
        }, true);

        $scope.list = tripOptionsService.getDropdownLists($scope.tripDetails);

        $scope.$watch('tripDetails.Locked', function(newValue) {
            if (newValue) {
                $scope.isLocked = newValue;
            }
        });

        $scope.isLocked = $scope.tripDetails.Locked;
        $scope.isDisable = [
            tripStatuses.CONFIRMED,
            tripStatuses.HELD,
            tripStatuses.PAST,
            tripStatuses.ENROUTE].includes($scope.tripDetails.Status);
        $scope.sentAlert = tripOptionsService.sentAlert();

        $scope.sendTripToReview = function(person) {

            /**
             * Redirect to login page if anonymus clicked on the link
             */
            if ($rootScope.readOnlyMode) {
                $state.go('login');
            }

            /**
             *  ignore if PAssenger ID was not found
             */
            if (!person.Id && !person.TripPassengerId) {
                return false;
            }

            $scope.sentAlert.show(false);

            const request = {
                TripId: tripId,
                TripPassengerId: person.Id || person.TripPassengerId,
            };

            /**
             * Send for review to travellers
             */
            tripAPI.sendTripToReview(request)
                .then(() => ktAlert.success(l10nService.localize('Trip shared')));
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsTravellersController.js